import React from 'react'
import { injectIntl } from 'react-intl'

import head from 'lodash/head'
import compact from 'lodash/compact'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { getDefaultSeller } from '@/checkout-instore-legacy/seller/utils'
import {
  goToProduct,
  cleanImageUrl,
} from '@/checkout-instore-legacy/utils/ProductUtils'

import Price from '@/checkout-instore-legacy/components/Commons/Price'

interface ProductCardProps {
  product: Product
  router: any
  intl: any
}

function ProductSuggestionsCard({ product, router, intl }: ProductCardProps) {
  function selectSku(): Item | undefined {
    const { skus } = product

    const defaultSku =
      compact(skus).find((sku) => {
        const { sellers } = sku
        const defaultSeller = getDefaultSeller(sellers)
        return (
          defaultSeller &&
          defaultSeller.commertialOffer &&
          defaultSeller.commertialOffer.availableQuantity > 0
        )
      }) || head(skus)

    return defaultSku
  }

  const item = selectSku()

  function getProductPrice() {
    return (item && item.sellers && item.sellers[0].commertialOffer.price) || 0
  }

  function getProductImageUrl() {
    const firstImage = item && head(item.images)
    return firstImage && cleanImageUrl(firstImage)
  }

  const handleGoToProductPage = () => {
    if (item) {
      goToProduct(router, item)
    }
  }

  return (
    <div
      id={`suggested-product-item-${product.id}`}
      className="flex flex-column ma3 pa0 w136 bg-white ba br2 b--light-gray flex-shrink-0 pointer"
      onClick={handleGoToProductPage}
    >
      <div>
        <img src={getProductImageUrl()} className="cover-image h136 w136" />
      </div>
      <div className="flex flex-column pa4 pt6 h-100 content-between">
        <p className="f7-s ma0 mb6 truncate ws-normal line-clamp flex-grow-1">
          {product.name}
        </p>
        <p className="ma0">
          <span className="f7-s mid-gray">
            {intl.formatMessage({ id: 'from' })}
          </span>
          <span className="b">
            {/* // TODO: this error popped up when moving the checkout-instore project
            // to checkout-instore-legacy, but needs to be fixed at some point
            // @ts-ignore */}
            <br /> <Price value={getProductPrice()} />
          </span>
        </p>
      </div>
    </div>
  )
}

export const ProductSuggestionsCardLoading = (key: any) => {
  return (
    <div
      key={key}
      className="bg-white w136 ma3"
      id={`suggested-card-loading-${key}`}
    >
      <div className="bg-light-gray h136 w136" />
      <div className="flex flex-column pa4 pt6 h-100 content-between">
        <p
          data-testid="name-skeleton-loading"
          className="lh-copy mocked light-silver text-loading ma0 mb6"
        >
          'xxxxxxxxxx'
        </p>
        <p
          data-testid="price-skeleton-loading"
          className="lh-copy mocked light-silver text-loading ma0"
        >
          'xxx xxxxx'
        </p>
      </div>
    </div>
  )
}

export default injectIntl(withRouter(ProductSuggestionsCard))
